import { NavLink } from 'react-router-dom';
import { Briefcase, Key, ShieldCheck, Plug, Settings, LayoutDashboard } from 'lucide-react';
import { Select } from '@/components/ui/select';
import type { OrgMeta } from '@shared/protocol';
import { cn } from '@/lib/utils';

interface SidebarProps {
  org: OrgMeta;
  orgs: OrgMeta[];
  switchOrg: (orgId: string) => void;
}

const NAV = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/jobs', label: 'Jobs', icon: Briefcase },
  { to: '/keys', label: 'API Keys', icon: Key },
  { to: '/credentials', label: 'Credentials', icon: ShieldCheck },
  { to: '/integrations', label: 'Integrations', icon: Plug },
  { to: '/settings', label: 'Settings', icon: Settings },
];

export function Sidebar({ org, orgs, switchOrg }: SidebarProps) {
  return (
    <aside className="w-60 border-r bg-card flex flex-col">
      <div className="p-4 border-b">
        <div className="font-semibold text-lg">Pure</div>
      </div>
      <div className="p-3 border-b">
        {orgs.length > 1 ? (
          <Select value={org.id} onChange={(e) => switchOrg(e.target.value)}>
            {orgs.map((o) => (
              <option key={o.id} value={o.id}>
                {o.name}
              </option>
            ))}
          </Select>
        ) : (
          <div className="text-sm px-2 py-1">
            <div className="font-medium truncate">{org.name}</div>
            <div className="text-xs text-muted-foreground">{org.role}</div>
          </div>
        )}
      </div>
      <nav className="flex-1 p-2 space-y-0.5">
        {NAV.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/dashboard'}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors',
                isActive
                  ? 'bg-accent text-accent-foreground font-medium'
                  : 'text-muted-foreground hover:text-foreground hover:bg-accent/50',
              )
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
